import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cockpit = defineConnector({
  identifier: "cockpit",
  name: "Cockpit",
  tagLine: "Self-hosted headless CMS",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ url }) =>
    url
      ? `${url.replace(/\./g, "\\.").replace(/\//g, "\\/")}/.*`
      : "https://.*",
  auth: (app) => queryAuth([{ name: "token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Cockpit CMS instance, go to **Settings → API Access** to find your access token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "url",
          label: "Cockpit URL",
          required: true,
          target: { kind: "configuration", field: "url" },
          placeholder: "https://cockpit.example.com",
          helperText: "The base URL of your Cockpit CMS instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ url }) => `${url}/api/collections/listCollections`,
  },
});
